import React from 'react';
import './Blogs.css';

const Blogs = () => {
    return (
        <div id="blogs">
            <div className="blogs section-container">
                <div className="blogs-header">
                    <h1 className="section-title">Bl<span>o</span>gs</h1>
                </div>
                <div className="blogs-items d-flex flex-column justify-content-center align-items-center">
                    <i className="fas fa-book-open"></i>
                    <h3 className="blogs-content">Blogs content coming soon</h3>
                </div>
            </div>
        </div>
    );
};

export default Blogs;